import React from 'react';
import { StanFilterConfig, StanFilterValue } from './types';
import DateFilter from './fields/DateFilter';
import NumberFilter from './fields/NumberFilter';
import SelectFilter from './fields/SelectFilter';
import TextFilter from './fields/TextFilter';

interface StanFilterChipProps {
    id: string;
    label: string;
    filterItem: StanFilterConfig;
    disabled?: boolean;
    onApply: (filters: StanFilterValue[]) => void;
    onClearFilter?: (id: string) => void;
    placement?: 'bottom' | 'bottom-start' | 'bottom-end' | 'top' | 'top-start' | 'top-end';
}

export const StanFilterChip: React.FC<StanFilterChipProps> = props => {
    switch (props.filterItem.type) {
        case 'text':
            return <TextFilter {...props} />;
        case 'number':
            return <NumberFilter {...props} />;
        case 'date':
            return <DateFilter {...props} />;
        case 'select':
            return <SelectFilter {...props} />;
        default:
            return null;
    }
};
